import * as EQError from "../utils/EQError";

export const STEP_PAUSE = 'pause';
export const STEP_MSCORE = 'mscore';

/**
 * Base class for each step executor.
 * It uses promise to run the test on the start method.
 *
 * <b>/*\ SUBCLASS MUSTN'T OVERRIDE {@link StepExecutor#start} and {@link StepExecutor#stop} METHODS</b>
 */
export default class StepExecutor {

    constructor(configuration) {
        this.configuration = configuration;
        this.cancelled = false;
        this.running = false;
    }

    /**
     * Start the step
     *
     * /*\ DON'T OVERRIDE THIS METHOD, OVERRIDE {@link startInternal}
     *
     * @param {function} progress callback on step progress
     *
     * @return {Promise}
     */
    start(progress) {
        return new Promise((resolve, reject) => {
            this.running = true;
            this.startInternal((result) => {
                this.running = false;
                resolve(result);
            }, (rejectCause) => {
                this.running = false;
                reject(rejectCause);
            }, progress);
        });
    }

    /**
     * Subclass should start the test
     * @param {function} resolve callback will be called with object contains data computed
     * @param {function} reject callback will be called with a EQError (see {@link EQError} constants)
     * @param {function} progress callback called with an id, the progress in percent and information contains in an object (progress(1, 90, {th:'123.2'})
     */
    /*eslint-disable no-unused-vars*/
    startInternal(resolve, reject, progress) {
        reject(new EQError(EQError.SCRIPT_STEP_NOT_IMPLEMENTED));
    }

    /**
     * @return {boolean} true if the step has been cancelled
     */
    isCancelled() {
        return this.cancelled;
    }

    /**
     * Stop the step
     * /*\ DON'T OVERRIDE THIS METHOD, OVERRIDE {@link stopInternal}
     * @return {boolean} true if the test has stopped (or will stop), false otherwise. The promise from the start will be rejected.
     */
    stop() {
        if (this.running && !this.cancelled) {
            this.cancelled = true;
            return this.stopInternal();
        }
        return false;
    }

    stopInternal() {
        return false;
    }
}



// WEBPACK FOOTER //
// ./js/core/script/StepExecutor.js